(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-guarantee-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-eu-guarantee-open]');
    const dialog = document.getElementById('eu-guarantee-dialog');
    if (opener && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
    }
    if (event.target.closest('[data-eu-guarantee-close]') && dialog?.open) dialog.close();
    if (event.target === dialog && dialog?.open) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
